import Entry from './layers/entry'
import States from './layers/states'
import Analytics from './layers/analytics'
import Token from './layers/token'
import Identification from './layers/identification'
import Product from './layers/product'
import Dashboard from './layers/dashboard'
import Comms from './layers/comms'
import MessageHandlers from './layers/messages'
import Style from './layers/style'
import Widget from './layers/widget'
import { ParafinProduct } from './layers/entry/types'

type ButtonStyle = {
    textColor: string
    backgroundColor: string
    fontSize: string
    height: string
    borderRadius: string
}

type Props = {
    token: string
    environment: 'development' | 'production'
    onExit?: (metadata: any) => void
    onExitV2?: (metadata: any) => void
    style: Partial<ButtonStyle>
    product: ParafinProduct
}

export default function WidgetWrapper({ token, environment, onExit, onExitV2, style, product }: Props) {
    return (
        <Entry
            token={token}
            environment={environment}
            onExit={onExit}
            onExitV2={onExitV2}
            style={style}
            product={product}
        >
            <States>
                <Analytics>
                    <Token>
                        <Identification>
                            <Product>
                                <Dashboard>
                                    <Comms>
                                        <MessageHandlers>
                                            <Style>
                                                <Widget />
                                            </Style>
                                        </MessageHandlers>
                                    </Comms>
                                </Dashboard>
                            </Product>
                        </Identification>
                    </Token>
                </Analytics>
            </States>
        </Entry>
    )
}